import axios from 'axios'
import qs from 'qs'
import { createForm, editForm, deleteForm, decodeForm } from '@/util/libForm'
import { defaultTtForm } from '@/util/defaultTtForm'
import { defaultQueryForm } from '@/util/defaultQueryForm'
import { getDefaultStrDate, objectSnakeToCamelCase, objectCamelToSnakeCase, clone } from '../../util/libUtil'
import defaultAtencionAgendadoForm from '@/util/atenciones/defaultAtencionAgendadoForm'
import defaultAtencionGestionForm from '@/util/atenciones/defaultAtencionGestionForm'
import defaultDireccionForm from '@/util/defaultDireccionForm'
import defaultAtencionNoInterestForm from '../../util/atenciones/defaultAtencionNoInterestForm'
import defaultNotasForm from '@/util/atenciones/defaultNotasForm'

function countNotEmptyObj(obj) {
    let count = 0
    Object.entries(obj).reduce((a, [k, v]) => {
        if (Array.isArray(v)) {
            if (!v.length)
                return a
        }
        if (v) {
            count++
            return (a[k] = v, a)
        } else {
            return a
        }
    }, {})
    return count
}

function todayString() {
    let tzoffset = (new Date()).getTimezoneOffset() * 60000
    return (new Date(Date.now() - tzoffset)).toISOString().substr(0, 10)
}

const state = () => ({
    // Objeto que guarda el estado inicial del formulario para la comprobacion de
    UntouchedTtForm: clone(defaultTtForm),
    // Objeto que presenta el formulario de editar y añadir entradas
    TtForm: clone(defaultTtForm),
    AddTtForm: clone(defaultTtForm),
    // Objeto que representa el formulario de consulta
    QueryForm: clone(defaultQueryForm),
    N_Filters: 0,
    // Estado del cuadro de dialogo del formulario
    IsOpenTtFormDialog: false,
    // Puede editarse o no el TtForm
    IsTtFormEdit: true,
    // Estado del dialogo del formulario completo con vista simple e historico
    IsOpenCompleteViewTtFormDialog: false,
    // Estado del formulario para agendar
    IsOpenScheduleForm: false,
    // Estado del formulario para no interesado
    IsOpenNoInterestForm: false,
    //  Estado del formulario de gestiones
    IsOpenAdministrationForm: false,
    // Estado del cuadro de dialogo del filtrado
    IsOpenTtQueryDialog: false,
    // Estado del diálogo de descarga de la bbdd
    IsOpenSpreadsheetDialog: false,
    spreadSheetHeaders: [],
    // Tipo de peticion que enviara el formulario POST para crear entradas y PUT para editar
    TtFormType: 'create',
    // Objeto que contiene todos los comerciales
    Comerciales: [],
    // Contiene los parametros de filtrado para la tabla
    QueryParams: {},
    // Lista que contiene los datos de la tabla del teletrabajo tal y como los devuelve el servidor
    TableData: [],
    // Estado de la tabla, cargando o no
    IsTableLoading: false,
    // Operadores disponibles
    isp: [],
    // Tipos de Gestiones
    administrations: [],
    windowTtForm: 0,

    CompleteViewTtForm: {
        idTtCliente: null,
        dialog: {
            IsOpen: false
        },
        details: {
            isLoading: false,
            form: {},
            facturas: {}
        },
        contracts: [],
        log: [],
        notas: [],
        isLoadingNotas: false,
        isLoadingLog: false,
        isLoadingContracts: false,
        isLoadingFacturas: false,
        isLoadingRenuevo: false,
        renuevoData: null,
    },
    registersViewTtForm: {
        registersData: null,
        isLoadingRegisters: false,
        isOpenRegisters: false,
    },
    clienteOpciones: null,
    // Guarda un int que indica si se esta viendo la tabla o un cliente
    currentView: 0,
    // Total de entradas del teletrabajo
    TotalTTEntries: 0,

    // Schedule Form Variables
    ScheduleForm: {
        isOpen: false,
        isSaving: false,
        isEditable: true,
        form: clone(defaultAtencionAgendadoForm)
    },

    // NoInterestForm Variables
    NoInterestForm: {
        isOpen: false,
        isSaving: false,
        isEditable: true,
        form: clone(defaultAtencionNoInterestForm)
    },

    // NotasForm Variables
    NotasForm: {
        isOpen: false,
        isSaving: false,
        isEditable: true,
        form: clone(defaultNotasForm)
    },

    // AdministrationForm Form Variables
    AdministrationForm: {
        isOpen: false,
        isEditing: true,
        isLoading: false,
        form: { ...clone(defaultAtencionGestionForm), gestion: null }
    },

    // Linea seleccionada en la vista detallada
    selectedLinea: null,
    selectorTarifa: {
        selectedTarifaIndex: 0,
        selectedLineaTarifaIndex: 0,
    },

    // Exportame tu vida
    // Exporting Progress :D
    // selectedAdministrationType: '',
    // selectedAdministrationOperator: '',
    // isEditableAdministrationForm: true,

    // Pagina de la tabla
    TablePage: 1,
    TtEntriesPath: '/api/clientes/entradas/',
    TtClienteDetailedPath: '/api/scraping/yoigo/cliente/',
    LocalidadPath: '/api/utils/localidades-from-cp/',
    ComercialesPath: '/api/comerciales/',
    TtClienteHistoricoPath: '/api/atenciones/historico/',
    TtClienteContractsPath: '/api/atenciones/contracts/',
    TtClienteFacturasPath: '/api/scraping/yoigo/cliente/facturas/',
    TtClienteRegistrosPath: '/api/scraping/yoigo/cliente/registros/',
    TtClienteRenuevoPath: '/api/scraping/yoigo/cliente/renuevo/',
    TtClienteRenuevoPDFPath: '/api/scraping/yoigo/cliente/renuevo/pdf/',
    TtClienteRenuevoPDFPath2: '/api/scraping/yoigo/cliente/renuevo/pdf2/',
    AtencionPath: '/api/atenciones/entradas/',
    NotasPath: '/api/clientes/notascliente/',
    getXLSX: '/api/clientes/teletrabajo/download-xlsx-teletrabajo/',
    taskIdPath: '/api/utils/task-status/',
    FilesPath: '/api/utils/get-xlsx-files/',
})

const actions = {
    setDefaultTtForm({ commit }) {
        commit('TtForm', clone(defaultTtForm))
    },
    setDefaultAddTtForm({ commit }) {
        commit('AddTtForm', clone(defaultTtForm))
    },
    setDefaultQueryForm({ commit, state }) {
        commit('QueryForm', clone(defaultQueryForm))
    },
    addTtForm({ commit, state, rootState }) {
        // dispatch('setDefaultTtForm')
        let form = {
            ...state.AddTtForm,
        }

        commit('TtFormType', 'create')
        commit('TtForm', clone(form))
        commit('UntouchedTtForm', clone(form))
        commit('IsTtFormEdit', true)
        commit('IsOpenTtFormDialog', true)
    },
    editTtForm({ commit, dispatch, rootState, state }, form) {
        let formxd = {
            ...form,
        }
        // form.name = form.full_name
        commit('TtFormType', 'edit')
        commit('UntouchedTtForm', { ...clone(formxd), fecha_contacto: todayString(), })
        commit('TtForm', { ...clone(formxd), fecha_contacto: todayString() })
        commit('IsOpenCompleteViewTtFormDialog', true)
        dispatch('fetchTtClienteHistorico', form.id)
        dispatch('fetchTtClienteContracts', form.id)
        dispatch('fetchTtClienteNotas', form.id)
    },
    viewTtForm({ commit, dispatch }, form) {
        // form.name = form.full_name
        commit('TtForm', clone(form))
        commit('UntouchedTtForm', clone(form))
        commit('TtFormType', 'view')
        commit('IsOpenCompleteViewTtFormDialog', true)
        dispatch('fetchTtClienteHistorico', form.id)
        dispatch('fetchTtClienteContracts', form.id)
        dispatch('fetchTtClienteNotas', form.id)
    },
    deleteTtForm({ dispatch, getters }, form) {
        deleteForm(getters.TtEntriesEndpoint, form)
            .then(() => {
                dispatch('getTableData')
                dispatch('util/showStatusSnackBar', {
                    statusType: 'success',
                    message: 'Eliminado correctamente'
                }, { root: true })
            }).catch(() => {
                dispatch('util/showStatusSnackBar', {
                    statusType: 'error',
                    message: 'Ha habido un error'
                }, { root: true })
            })
    },
    saveTtForm({ state, dispatch, getters, commit }) {
        let form = clone(state.TtForm)
        if (form.documento == "")
            form.documento = null

        if (form.lastAtencion) {
            delete form.lastAtencion
        }

        if (form.direccion) {
            if (form.direccion.direccion?.trim() == "")
                form.direccion.direccion = null
            if (form.direccion.cp?.trim() == "")
                form.direccion.cp = null
            if (form.direccion.localidad?.trim() == "")
                form.direccion.localidad = null
        }

        return new Promise((resolve, reject) => {
            let promise;
            if (state.TtFormType == 'edit') { // Hay dos tipos de formulario, edit  y create
                promise = editForm(getters.TtEntriesEndpoint, form)
            } else if (state.TtFormType == 'create') {
                promise = createForm(getters.TtEntriesEndpoint, form)
            }
            promise.then((response) => {
                dispatch('util/showStatusSnackBar', {
                    statusType: 'success',
                    message: 'Guardado correctamente'
                }, { root: true })
                dispatch('getTableData')
                // dispatch('setDefaultTtForm')
                // if (state.TtFormType == 'create')
                //     dispatch('setDefaultAddTtForm')
                commit('TtForm', response.data)
                resolve(response)
                commit('TtFormType', 'edit')

            }).catch(error => {
                let message = 'Ha habido un problema'
                // if (error.response.data.message)
                //     message = error.response.data.message
                reject('Error')
                dispatch('util/showStatusSnackBar', {
                    error: error,
                    timeout: 7000,
                    statusType: 'error',
                    message: message
                }, { root: true })
            })
        })
    },
    closeTtFormDialog({ commit, state }) {
        commit('IsOpenTtFormDialog', false)
        commit('windowTtForm', 0)
        if (state.TtFormType == 'create') {
            commit('AddTtForm', clone(state.TtForm))
        }
    },
    openTtQueryDialog({ commit }) {
        commit('IsOpenTtQueryDialog', true)
    },
    closeTtQueryDialog({ commit }) {
        commit('IsOpenTtQueryDialog', false)
    },
    closeCompleteViewTtFormDialog({ commit, state }) {
        commit('IsOpenCompleteViewTtFormDialog', false)
        if (state.TtFormType == 'create') {
            commit('AddTtForm', clone(state.TtForm))
        }
    },
    openCompleteViewTtQueryDialog({ commit }) {
        commit('IsOpenCompleteViewTtQueryDialog', true)
    },
    fetchComerciales({ commit, getters }) {
        return new Promise((resolve, reject) => {
            axios.get(getters.ComercialesEndpoint).then((response) => {
                response.data = objectSnakeToCamelCase(response.data)
                let comerciales = [
                    ...response.data.filter(({ nombreCompleto, estado }) => !nombreCompleto.includes('invitado') && estado == 'ALTA'),
                    ...response.data.filter(({ nombreCompleto, estado }) => !nombreCompleto.includes('invitado') && estado == 'VACACIONES'),
                    ...response.data.filter(({ nombreCompleto, estado }) => !nombreCompleto.includes('invitado') && estado == 'BAJA'),
                    ...response.data.filter(({ nombreCompleto, estado }) => !nombreCompleto.includes('invitado') && estado == 'INACTIVO'),
                    // ...response.data.filter(
                    //     ({ nombreCompleto }) => nombreCompleto.includes('invitado')).sort((a, b) =>
                    //         (parseInt(a.nombreCompleto.replace(/.*[a-z]/, '')) > parseInt(b.nombreCompleto.replace(/.*[a-z]/, ''))) ? 1 : -1),
                    // ...response.data.filter(({ nombreCompleto, estado }) => !nombreCompleto.includes('invitado') && estado != 'ALTA').sort((a, b) => a.estado > b.estado),

                ]
                comerciales.push({ id: 'null', nombre: 'Por asignar', nombreCompleto: 'Por asignar' })
                commit('Comerciales', comerciales)
            }).then(() => {
                resolve('success')
            }).catch(() => {
                reject('error')
            })
        })
    },
    async getTableData({ commit, getters, state }) {
            if(!state.IsTableLoading) {
                return new Promise((resolve, reject) => {
                commit('IsTableLoading', true)
                state.N_Filters = countNotEmptyObj(state.QueryForm) + (state.QueryParams.search ? 1 : 0)
                axios.get(getters.TtEntriesEndpoint, {
                    params: state.QueryParams,
                    paramsSerializer: params => {
                        return qs.stringify(params, { arrayFormat: 'brackets', skipNulls: true })
                    },
                }).then((response) => {
                    // Array.from convierte el diccionario que devuelve a un array
                    commit('TableData', objectSnakeToCamelCase(response.data.results))
                    commit('TotalTTEntries', response.data.count)
                    commit('TablePage', response.data.current)
                    commit('IsTableLoading', false)
                    resolve('Sucess')
                }).catch(() => {
                    commit('IsTableLoading', false)
                    reject('Error')
                })
            })
        }
    },
    exportDB({ state, dispatch }) {
        let copyparams = state.QueryParams
        copyparams['headers'] = state.spreadSheetHeaders
        state.N_Filters = countNotEmptyObj(state.QueryForm) + (state.QueryParams.search ? 1 : 0)

        dispatch('util/exportDB', {
            path: state.getXLSX,
            params: copyparams, paramsSerializer: params => { return qs.stringify(params, { arrayFormat: 'brackets', skipNulls: true }) },
            title: `ReporteTeletrabajo_${getDefaultStrDate(new Date())}`,
        }, { root: true })
    },
    async fetchTtClienteDetailed({ commit, getters, dispatch }, document) {
        commit('IsLoadingTtClienteDetails', true)
        dispatch('agent/agentCustomerInfo', document, { root: true }).
        then((response) => {
            if (response?.request_error) {
                commit('currentView', 'Teletrabajo')
                commit('CompleteViewTtFormDetailsForm', {})
                dispatch('util/showStatusSnackBar', {
                    statusType: 'error',
                    message: `No se ha encontrado al cliente`,
                }, { root: true })
            }
        })
        commit('IsLoadingTtClienteDetails', false)
    },
    async fetchTtClienteRenuevo({ state, commit, getters, dispatch }, { documentoParam, msisdnParam }) {
        commit('IsLoadingTtClienteRenuevo', true)
        let msisdn = msisdnParam ? msisdnParam : state.selectedLinea
        let documento = {
            type: null,
            identificationId: null,
        }

        if (documentoParam) {
            documento = clone(documentoParam)
        } else {
            documento = clone(state.CompleteViewTtForm.details.form['INFO_CLIENTE']['documentation'][0])
            if (Object.keys(state.CompleteViewTtForm.details.form['INFO_AUTORIZADO']).length > 0 && state.CompleteViewTtForm.details.form['INFO_CLIENTE']['documentation'][0]['type'] == 'CIF') {
                documento.type = state.CompleteViewTtForm.details.form['INFO_AUTORIZADO']['authorized-person-id-number-type']
                documento.identificationId = state.CompleteViewTtForm.details.form['INFO_AUTORIZADO']['authorized-person-id-number']
                documento['cif'] = state.CompleteViewTtForm.details.form['INFO_CLIENTE']['documentation'][0]['identificationId']
            }
        }

        try {
            let resp = await axios.get(getters.TtClienteRenuevoEndpoint, {
                params: { ...documento, ...{ msisdn: msisdn } },
            })
            commit('IsLoadingTtClienteRenuevo', false)
            commit('renuevoData', objectSnakeToCamelCase(resp.data))
        } catch (error) {
            commit('IsLoadingTtClienteRenuevo', false)
            dispatch('util/showStatusSnackBar', {
                statusType: 'error',
                message: 'Error al obtener datos sobre el renuevo'
            }, { root: true })
            throw error
        }
    },
    async downloadPdfRenuevo({ state, commit, getters, dispatch }, { documentoParam, msisdnParam }) {
        let msisdn = msisdnParam ? msisdnParam : state.selectedLinea
        let documento = {
            type: null,
            identificationId: null,
        }

        if (documentoParam) {
            documento = documentoParam
        } else {
            documento = state.CompleteViewTtForm.details.form['INFO_CLIENTE']['documentation'][0]
        }

        try {
            let resp = await axios.get(getters.TtClienteRenuevoPDFEndpoint, {
                params: { ...documento, ...{ msisdn: msisdn, pdf_id: state.CompleteViewTtForm.renuevoData.pdfId } },
                responseType: "blob"
            })

            const blob = new Blob([resp.data], { type: 'application/pdf' })

            var fileURL = window.URL.createObjectURL(blob)
            var fileLink = document.createElement('a')

            fileLink.href = fileURL
            fileLink.setAttribute('download', resp.headers['content-disposition'] ? resp.headers['content-disposition'].split('filename=')[1] : `Renuevo_${document['identificationId']}${document['type']}_${state.selectedLinea}${getDefaultStrDate(new Date())}`)
            document.body.appendChild(fileLink)

            fileLink.click();
            document.body.removeChild(fileLink)
            window.URL.revokeObjectURL(fileURL)

        } catch (error) {
            dispatch('util/showStatusSnackBar', {
                statusType: 'error',
                message: 'Error al descargar el PDF de renuevo'
            }, { root: true })
            throw error
        }
    },
    async downloadPdfRenuevo2({ state, commit, getters, dispatch }, { documentoParam, msisdnParam }) {
        commit('IsLoadingTtClienteRenuevo', true)
        let msisdn = msisdnParam ? msisdnParam : state.selectedLinea
        let documento = {
            type: null,
            identificationId: null,
        }

        if (documentoParam) {
            documento = documentoParam
        } else {
            documento = state.CompleteViewTtForm.details.form['INFO_CLIENTE']['documentation'][0]
        }

        try {
            let resp = await axios.get(getters.TtClienteRenuevoPDF2Endpoint, {
                params: { ...documento, ...{ msisdn: msisdn } },
                responseType: "blob"
            })

            const blob = new Blob([resp.data], { type: 'application/pdf' })

            var fileURL = window.URL.createObjectURL(blob)
            var fileLink = document.createElement('a')

            fileLink.href = fileURL
            fileLink.setAttribute('download', resp.headers['content-disposition'] ? resp.headers['content-disposition'].split('filename=')[1] : `Renuevo_${document['identificationId']}${document['type']}_${state.selectedLinea}${getDefaultStrDate(new Date())}`)
            document.body.appendChild(fileLink)

            commit('IsLoadingTtClienteRenuevo', false)
            fileLink.click();
            document.body.removeChild(fileLink)
            window.URL.revokeObjectURL(fileURL)
        } catch (error) {
            commit('IsLoadingTtClienteRenuevo', false)
            dispatch('util/showStatusSnackBar', {
                statusType: 'error',
                message: 'Error al descargar el PDF de renuevo'
            }, { root: true })
            throw error
        }
    },

    async fetchTtClienteRegistros({ state, commit, getters, dispatch }) {
        try {
            commit('IsLoadingRegisters', true)
            let resp = await axios.get(getters.TtClienteRegistrosEndpoint, {
                params: { ...state.CompleteViewTtForm.details.form['INFO_CLIENTE']['documentation'][0], ...{ msisdns: getters.getLineasTtForm.join(',') } },
            })
            commit('registersData', resp.data.sort((a, b) => {
                return new Date(b.date) - new Date(a.date);
            }))
            commit('IsLoadingRegisters', false)
            dispatch('util/showStatusSnackBar', {
                statusType: 'success',
                message: 'Registros obtenidos correctamente'
            }, { root: true })
        } catch (error) {
            commit('IsLoadingRegisters', false)
            dispatch('util/showStatusSnackBar', {
                statusType: 'error',
                message: 'Error al obtener los registros'
            }, { root: true })
            throw error
        }
    },
    async fetchTtClienteFacturas({ state, commit, getters, dispatch }, { selectedMeses }) {
        return new Promise((resolve, reject) => {
            commit('IsLoadingTtClienteFacturas', true)
            commit('CompleteViewTtFormFacturas', {})
            axios.get(getters.TtClienteFacturasEndpoint, {
                params: { ...state.CompleteViewTtForm.details.form['INFO_CLIENTE']['documentation'][0], ...{ selectedMeses: selectedMeses } }
            })
                .then((response) => {
                    console.log(response)
                    commit('CompleteViewTtFormFacturas', response.data)
                    dispatch('util/showStatusSnackBar', {
                        statusType: 'success',
                        message: response.data.length > 0 ? 'Facturas cargadas correctamente' : 'El cliente no tiene facturas'
                    }, { root: true })
                    resolve('Success')
                })
                .catch(() => {
                    console.log('fail')
                    dispatch('util/showStatusSnackBar', {
                        statusType: 'error',
                        message: '¡Facturas no encontradas!'
                    }, { root: true })
                    commit('IsLoadingTtClienteFacturas', false)
                    commit('CompleteViewTtFormFacturas', {})
                    reject('Error')
                })
        })
    },
    async fetchTtClienteHistorico({ state, getters, commit }, idTtCliente) {
        return new Promise((resolve, reject) => {
            commit('IsLoadingTtClienteLog', true)
            commit('TtClienteLog', [])
            axios.get(getters.TtClienteHistoricoEndpoint + idTtCliente)
                .then((response) => {
                    commit('TtClienteLog', response.data)
                    resolve(response)
                    commit('IsLoadingTtClienteLog', false)
                })
                .catch((err) => {
                    commit('IsLoadingTtClienteLog', false)
                    reject(err)
                })
        })
    },
    async fetchTtClienteContracts({ state, getters, commit }, idTtCliente) {
        return new Promise((resolve, reject) => {
            commit('IsLoadingTtClienteContracts', true)
            commit('TtClienteContracts', [])
            axios.get(getters.TtClienteContractsEndpoint + idTtCliente)
                .then((response) => {
                    commit('TtClienteContracts', response.data)
                    resolve(response)
                    commit('IsLoadingTtClienteContracts', false)
                })
                .catch((err) => {
                    commit('IsLoadingTtClienteContracts', false)
                    reject(err)
                })
        })
    },
    async fetchTtClienteHistoricoFromOferta({ state, getters, commit }) {
        return new Promise((resolve, reject) => {
            commit('IsLoadingTtClienteLog', true)
            commit('TtClienteLog', [])


            axios.get(getters.TtClienteHistoricoEndpoint + state.TtForm.id)
                .then((response) => {
                    commit('TtClienteLog', response.data)
                    resolve(response)
                    commit('IsLoadingTtClienteLog', false)
                })
                .catch((err) => {
                    commit('IsLoadingTtClienteLog', false)
                    reject(err)
                })
        })
    },
    updateQueryParams({ commit, state }, params) {
        let newParams = { ...state.QueryParams, ...params }
        newParams = Object.entries(newParams).reduce((a, [k, v]) => (v ? (a[k] = v, a) : a), {}) // eliminate nulls
        commit('QueryParams', newParams)
    },
    updateQueryForm({ commit }, queryForm) {
        commit('QueryForm', clone(queryForm))
    },
    detailedView({ commit, dispatch, state }, document) {
        commit('currentView', 'Detailed')
        state.CompleteViewTtForm.idTtCliente = document
        dispatch('fetchTtClienteDetailed', document )
    },
    async getAdministrations({ dispatch, getters, rootState, commit }) {
        let resp = await axios.get(getters.getEndpointFromPath(rootState.ManagementBase.procedureManagement.paths.procedurePath), {
            params: {
                is_active: 1,
            },
        })
        try {
            commit('administrations', resp.data)
            // dispatch('util/showStatusSnackBar', {
            //     statusType: 'success',
            //     message: 'Gestiones Cargadas Correctamente'
            // }, {root: true})
        }
        catch {
            console.log('Error al cargar las gestiones')
            // dispatch('util/showStatusSnackBar', {
            //     statusType: 'error',
            //     message: 'No se pudo cargar el contenido'
            // }, {root: true})
        }
    },
    async addScheduled({ state, dispatch, getters }) {
        try {
            state.ScheduleForm.form.agendado.fechaAgendado = state.ScheduleForm.form.agendado.fechaAgendado.toISOString()
            await axios.post(getters.getEndpointFromPath(state.AtencionPath),
                objectCamelToSnakeCase(state.ScheduleForm.form)
            ).then(() => {
                dispatch('fetchTtClienteHistorico', state.TtForm.id)
            });
            dispatch('util/showStatusSnackBar', {
                statusType: 'success',
                message: 'Agendado Correctamente!',
            }, { root: true })
        } catch (error) {
            dispatch('util/showStatusSnackBar', {
                error: error,
                timeout: 8000,
                statusType: 'error',
                message: 'Error al agendar',
            }, { root: true })
        }
    },
    async addNoInterest({ state, dispatch, getters }) {
        try {
            await axios.post(getters.getEndpointFromPath(state.AtencionPath),
                objectCamelToSnakeCase(state.NoInterestForm.form)
            ).then(() => {
                dispatch('fetchTtClienteHistorico', state.TtForm.id)
            });
            dispatch('util/showStatusSnackBar', {
                statusType: 'success',
                message: 'No interesado añadido correctamente!',
            }, { root: true })
        } catch (error) {
            dispatch('util/showStatusSnackBar', {
                error: error,
                timeout: 8000,
                statusType: 'error',
                message: 'Error al añadir no interesado',
            }, { root: true })
        }
    },
    async addNotas({ state, dispatch, getters }) {
        try {
            // Esto está feísimo, pero tengo prisa. Da igual cuando leas esto en MM.
            if (typeof (state.NotasForm.form.comercial) == 'object')
                state.NotasForm.form.comercial = state.NotasForm.form.comercial.id

            await axios.post(getters.getEndpointFromPath(state.NotasPath),
                objectCamelToSnakeCase(state.NotasForm.form)
            ).then(() => {
                dispatch('fetchTtClienteNotas', state.TtForm.id)
            });
            dispatch('util/showStatusSnackBar', {
                statusType: 'success',
                message: 'Nota añadido con éxito!',
            }, { root: true })
        } catch {
            dispatch('util/showStatusSnackBar', {
                statusType: 'error',
                message: 'Error al añadir nota',
            }, { root: true })
        }
    },
    async fetchTtClienteNotas({ state, getters, commit }, idTtCliente) {
        return new Promise((resolve, reject) => {
            commit('IsLoadingTtClienteNotas', true)
            commit('TtClienteNotas', [])
            axios.get(`${getters.getEndpointFromPath(state.NotasPath)}?client_id=${idTtCliente}`)
                .then((response) => {
                    commit('TtClienteNotas', response.data)
                    resolve(response)
                    commit('IsLoadingTtClienteNotas', false)
                })
                .catch((err) => {
                    commit('IsLoadingTtClienteNotas', false)
                    reject(err)
                })
        })
    },
    async addAdministration({ state, dispatch, getters }) {
        try {
            await axios.post(getters.getEndpointFromPath(state.AtencionPath),
                objectCamelToSnakeCase(state.AdministrationForm.form)
            ).then(() => {
                dispatch('fetchTtClienteHistorico', state.TtForm.id)
            });
            dispatch('util/showStatusSnackBar', {
                statusType: 'success',
                message: 'Gestión Registrada Correctamente!',
            }, { root: true })
        } catch (error) {
            dispatch('util/showStatusSnackBar', {
                error: error,
                timeout: 8000,
                statusType: 'error',
                message: 'Error al Registrar la Gestión',
            }, { root: true })
        }
    },
    async getAgendadosToday({ state, getters, commit, rootState, dispatch, rootGetters }) {
        if (rootGetters['login/hasComercialPermission'] || rootGetters['login/hasOnlyManagerPermission']) {
            try {
                dispatch('dashboard/fetchAgendados', {}, { root: true })
                setTimeout(() => {
                    dispatch('util/showStatusSnackBar', {
                        statusType: 'info',
                        timeout: 10000,
                        message: `Bienvenid@ ${rootState.login.nombre}, agendados para hoy: ${rootState.dashboard.estadisticaAgendados.agendados.length}`,
                    }, { root: true })
                }, 3000)
            } catch (error) {
                console.log(console.log(error));
            }
        }

    }
}

const getters = {
    allComerciales: (state) => {
        return state.Comerciales
    },
    selectedComercial: (state, _unused, rootState) => (
        state.Comerciales.find(({ id }) => (id == rootState.login.id))
    ),
    TtEntriesEndpoint: (state, _unused, rootState) => (
        rootState.general.host + state.TtEntriesPath
    ),
    ComercialesEndpoint: (state, _unused, rootState) => (
        rootState.general.host + state.ComercialesPath
    ),
    LocalidadEndpoint: (state, _unused, rootState) => (
        rootState.general.host + state.LocalidadPath
    ),
    TtClienteDetailedEndpoint: (state, _unused, rootState) => (
        rootState.general.host + state.TtClienteDetailedPath
    ),
    TtClienteHistoricoEndpoint: (state, _unused, rootState) => (
        rootState.general.host + state.TtClienteHistoricoPath
    ),
    TtClienteContractsEndpoint: (state, _unused, rootState) => (
        rootState.general.host + state.TtClienteContractsPath
    ),
    TtClienteFacturasEndpoint: (state, _unused, rootState) => (
        rootState.general.host + state.TtClienteFacturasPath
    ),
    TtClienteRegistrosEndpoint: (state, _unused, rootState) => (
        rootState.general.host + state.TtClienteRegistrosPath
    ),
    TtClienteRenuevoEndpoint: (state, _unused, rootState) => (
        rootState.general.host + state.TtClienteRenuevoPath
    ),
    TtClienteRenuevoPDFEndpoint: (state, _unused, rootState) => (
        rootState.general.host + state.TtClienteRenuevoPDFPath
    ),
    TtClienteRenuevoPDF2Endpoint: (state, _unused, rootState) => (
        rootState.general.host + state.TtClienteRenuevoPDFPath2
    ),
    getEndpointFromPath: (_state, _unused, rootState) => endpoint => (
        rootState.general.host + endpoint
    ),
    getLineasTtForm(state) {
        if (Object.keys(state.CompleteViewTtForm.details.form)) {
            let lineasCliente = [];
            state.CompleteViewTtForm.details.form.CONTRATOS[0].paquetes.forEach(({ productos }) => {
                lineasCliente.push(productos[0].lineas.map(({ id }) => (id)))
            })
            return lineasCliente.flat()
        }
    }
}

const mutations = {
    windowTtForm: (state, val) => {
        state.windowTtForm = val
    },
    selectedLinea: (state, val) => {
        state.selectedLinea = val
    },
    selectorTarifa: (state, val) => {
        state.selectorTarifa = clone({ ...state.selectorTarifa, ...val })
    },
    spreadSheetHeaders: (state, val) => {
        state.spreadSheetHeaders = clone(val)
    },
    IsOpenSpreadsheetDialog: (state, val) => {
        state.IsOpenSpreadsheetDialog = val
    },
    TtFormType: (state, val) => {
        state.TtFormType = val
    },
    IsTtFormEdit: (state, val) => {
        state.IsTtFormEdit = val
    },
    IsOpenTtFormDialog: (state, val) => {
        state.IsOpenTtFormDialog = val
    },
    IsOpenCompleteViewTtFormDialog: (state, val) => {
        state.CompleteViewTtForm.dialog.IsOpen = val
    },
    IsOpenAdministrationForm: (state, val) => {
        state.AdministrationForm.form.cliente = clone(state.TtForm)
        state.AdministrationForm.isOpen = val
    },
    IsOpenScheduleForm: (state, val) => {
        state.ScheduleForm.form.cliente = clone(state.TtForm)
        state.ScheduleForm.isOpen = val
    },
    IsOpenTtQueryDialog: (state, val) => {
        state.IsOpenTtQueryDialog = val
    },
    TtQueryDialog: (state, val) => {
        state.TtQueryDialog = val
    },
    UntouchedTtForm: (state, val) => {
        state.UntouchedTtForm = val
    },
    TtForm: (state, val) => {
        state.TtForm = objectSnakeToCamelCase(val)
        if (val.direccion == null) {
            state.TtForm.direccion = clone(defaultDireccionForm)
        }
        // Arreglo pancho TEMPORAL para lo de las direcciones
        // let ttform = objectSnakeToCamelCase(val)
        // if (val.direcciones && val.direcciones.length != 0) {
        //     ttform.direccion = val.direcciones[0]
        // } else {
        //     ttform.direccion = clone(defaultDireccionForm)
        // }

        // state.TtForm = ttform
    },
    TtClienteContracts: (state, val) => {
        state.CompleteViewTtForm.contracts = objectSnakeToCamelCase(val)
    },
    TtClienteLog: (state, val) => {
        state.CompleteViewTtForm.log = objectSnakeToCamelCase(val)
    },
    TtClienteNotas: (state, val) => {
        state.CompleteViewTtForm.notas = objectSnakeToCamelCase(val)
    },
    IsLoadingTtClienteLog: (state, val) => {
        state.CompleteViewTtForm.isLoadingLog = val
    },
    IsLoadingTtClienteContracts: (state, val) => {
        state.CompleteViewTtForm.isLoadingContracts = val
    },
    IsLoadingTtClienteNotas: (state, val) => {
        state.CompleteViewTtForm.isLoadingNotas = val
    },
    IsLoadingTtClienteDetails: (state, val) => {
        state.CompleteViewTtForm.details.isLoading = val
    },
    CompleteViewTtFormDetailsForm: (state, val) => {
        state.CompleteViewTtForm.details.form = val
    },
    CompleteViewTtFormFacturas: (state, val) => {
        state.CompleteViewTtForm.details.facturas = val
    },
    IsLoadingTtClienteFacturas: (state, val) => {
        state.CompleteViewTtForm.isLoadingFacturas = val
    },
    IsLoadingRegisters: (state, val) => {
        state.registersViewTtForm.isLoadingRegisters = val
    },
    IsLoadingTtClienteRenuevo: (state, val) => {
        state.CompleteViewTtForm.isLoadingRenuevo = val
    },
    isOpenRegisters: (state, val) => {
        state.registersViewTtForm.isOpenRegisters = val
    },
    registersData: (state, val) => {
        state.registersViewTtForm.registersData = val
    },
    renuevoData: (state, val) => {
        state.CompleteViewTtForm.renuevoData = val
    },
    AddTtForm: (state, val) => {
        state.AddTtForm = val
    },
    QueryForm: (state, val) => {
        state.QueryForm = val
    },
    Comerciales: (state, val) => {
        state.Comerciales = objectSnakeToCamelCase(val)
    },
    QueryParams: (state, val) => {
        state.QueryParams = val
    },
    TableData: (state, val) => {
        state.TableData = val
    },
    isp: (state, val) => {
        state.isp = val
    },
    administrations: (state, val) => {
        state.administrations = val
    },
    TotalTTEntries: (state, val) => {
        state.TotalTTEntries = val
    },
    TablePage: (state, val) => {
        state.TablePage = val
    },
    IsTableLoading: (state, val) => {
        state.IsTableLoading = val
    },
    currentView: (state, val) => {
        if (val == 'Detailed') {
            state.currentView = 1;
        } else {
            state.currentView = 0;
        }
    },
    clienteOpciones: (state, val) => {
        state.clienteOpciones = clone(val)
    },
    ScheduleForm: (state, val) => {
        state.ScheduleForm = val
    },
    NoInterestForm: (state, val) => {
        state.NoInterestForm = val
    },
    NotasForm: (state, val) => {
        state.NotasForm = val
    },
    AdministrationForm: (state, val) => {
        state.AdministrationForm = val
    },
    getEndpointFromPath: (_state, _unused, rootState) => endpoint => (
        rootState.general.host + endpoint
    )
}


export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}
